import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { Box } from "@mui/material";

interface SpinnerProps {
  spinnerText?: string;
}

const VisionStudioSpinner: React.FC<SpinnerProps> = ({ spinnerText }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      height: "100%",
      width: "100%",
    }}
  >
    <React.Fragment>
      <div
        style={{
          position: "fixed",
          top: "50%",
          left: "49.5%",
          textAlign: "center",
        }}
      >
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#e01cd5" />
              <stop offset="100%" stopColor="#1CB5E0" />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress
          size={80} // Adjust size for wider loader
          thickness={3} // Increase thickness for a thicker stroke
          sx={{ "svg circle": { stroke: "url(#my_gradient)" } }}
        />
        <p style={{ marginTop: "4px" }}>{spinnerText}</p>
      </div>
    </React.Fragment>
  </Box>
);

export default VisionStudioSpinner;
